<template>
  <div>
    <div class="d-flex flex-column align-items-stretch">
      <div class="d-flex justify-content-between">
        <div class="mb-1 me-1 col-md-2">
          <select class="form-control" :value="selectedSorting"
            @change="$emit('update:selectedSorting', $event.target.value)">
            <option v-for="so in sortOptions" :value="so">{{ so.value }}</option>
          </select>
        </div>
        <div class="">
          <button class="btn btn-sm bg-gradient-secondary mb-0 py-1" @click="showFilters">فیلترها</button>
        </div>
      </div>
      <div class="table-responsive p-0">
        <table class="table table-striped table-sm table-styled">
          <thead id="tLTH">
            <tr>
              <th scope="col"></th>
              <th scope="col">#</th>
              <th scope="col">زمان ثبت</th>
              <th scope="col">کد</th>
              <th scope="col">عنوان</th>
              <th scope="col">مجموعه</th>
              <th scope="col">کاربر درخواست کننده</th>
              <th scope="col">بخش هدف</th>
              <th scope="col">زمان صرف شده</th>
              <th scope="col">ثبت تا رسیدگی</th>
              <th scope="col">در انتظار پاسخ مشتری</th>
              <th scope="col">ثبت تا پاسخ</th>
              <th scope="col">وضعیت</th>
              <th scope="col">امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr></tr>
            <tr v-for="(t, index) in resultsList">
              <td>
                <fa-layers class="pointer" @click="ticketBookmarkToggle(t.id)">
                  <fa-icon class="c-yellow-600" icon="fas fa-bookmark" size="lg" />
                  <fa-icon :class="t.isBookmarked ? 'c-yellow-600' : 'text-white'" icon="fas fa-bookmark"
                    transform="up-1" />
                </fa-layers>
              </td>
              <td>
                <span class="pe-1">
                  {{ index + (pageIndex * pageSize) + 1 }}
                </span>
              </td>
              <td>
                {{ $filters.toDateString(t.createDate) }}
                <br />
                {{ $filters.toTimeString(t.createTime) }}
              </td>
              <td>{{ t.ticketCode }}</td>
              <td>
                <div class="d-flex flex-wrap align-items-center">
                  <div class="display-ruby">
                    <div v-if="t.ticketImportanceEnum > 0" class="table-importance p-1 mb-0 ms-2 h-0"
                      :class="t.ticketImportanceEnum > 1 ? 'bg-danger' : 'bg-warning'"
                      :title="t.ticketImportanceEnum == 1 ? 'سطح اهمیت متوسط' : 'سطح اهمیت بالا'">
                    </div>
                    <router-link :to="'/ticketDetails/' + t.id" class="text-not-hover-black ms-1">
                      {{ t.title }}
                    </router-link>
                  </div>
                  <div v-for="l in t.labels" class="chatbox-header-label text-nowrap fs-6 align-self-center my-0 mx-1 px-2 h-50">
                    {{ l.title }}
                  </div>
                </div>
              </td>
              <td>{{ t.createUser?.customerTitle ?? t.createUser?.companyTitle }}</td>
              <td class="">
                <div>{{ t.createUser?.firstName }} {{ t.createUser?.lastName }} - {{ t.createUser?.postTitle }}</div>
                <div v-if="t.lastChangeUser?.id" class="d-flex flex-column text-info">
                  <div>{{ t.lastChangeUser?.firstName }} {{ t.lastChangeUser?.lastName }} - {{
                    t.lastChangeUser?.postTitle }}</div>
                  <div>{{ $filters.toTimeString(t.lastChangeTime) }} - {{ $filters.toDateString(t.lastChangeDate) }}
                  </div>
                </div>
              </td>
              <td>{{ t.companySectionTitle }}</td>
              <td>{{ $filters.minutesToTimeString(t.totalTimeSpent) }}</td>
              <td>{{ $filters.minutesToTimeString(t.timeBeforeFirstCompanyChange) }}</td>
              <td>{{ $filters.minutesToTimeString(t.timeAwaitingCustomerResponse) }}</td>
              <td>{{ $filters.minutesToTimeString(t.timeTakenToAnswer) }}</td>
              <td>
                <div class="status table-status m-0 p-1"
                  :class="t.ticketStatusHistories?.[0]?.ticketStatus?.ticketStatusEnum == 0 ? 'status-danger' :
                    t.ticketStatusHistories?.[0]?.ticketStatus?.ticketStatusEnum == 1 ? 'status-warning' :
                      t.ticketStatusHistories?.[0]?.ticketStatus?.ticketStatusEnum == 2 ? 'status-primary' :
                        t.ticketStatusHistories?.[0]?.ticketStatus?.ticketStatusEnum == 3 ? 'status-success' :
                          t.ticketStatusHistories?.[0]?.ticketStatus?.ticketStatusEnum == 7 ? 'status-warning' : 'status-secondary'">
                  {{ t.ticketStatusHistories?.[0]?.ticketStatus?.title }}
                </div>
              </td>
              <td>
                <router-link :to="'/ticketDetails/' + t.id" class="btn btn-sm bg-gradient-primary td-button"
                  title="جزئیات">
                  <fa-icon icon="fas fa-envelope-open" />
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
        <Pagination :totalRecordCount="resultsList?.[0]?.totalRecordsCount ?? 0"
          :listPageSize="[10, 15, 20, 30, 50, 100]" :pageSize="pageSize" :pageIndex="pageIndex"
          @change-callback="updatePagination" />
        <hr class="horizontal dark" />
        <button class="btn btn-sm bg-gradient-secondary mb-0 py-1" @click="showFilters">فیلترها</button>
      </div>
    </div>
  </div>
</template>

<script>
import TicketService from '../../../services/Ticket/Ticket-service';

export default {
  emits: ['paginationUpdate', 'sortingUpdate', 'showFilters'],
  props: {
    resultsList: {
      type: Array
    },
    selectedSorting: {
      type: Object
    },
    pageSize: {
      type: Number
    },
    pageIndex: {
      type: Number
    }
  },
  data() {
    return {
      sortOptions: [
        { key: 0, value: 'قدیمی ترین تیکت' },
        { key: 1, value: 'جدیدترین تیکت' },
      ],
    }
  },
  watch: {
    selectedSorting() {
      this.$emit('sortingUpdate', this.selectedSorting);
    }
  },
  methods: {
    updatePagination(pageNumber, pageSize) {
      this.$emit('paginationUpdate', pageNumber - 1, pageSize);

      window.scrollTo(0, 0);
    },
    ticketBookmarkToggle(ticketId) {
      TicketService.ticketBookmarkToggle(ticketId).then(response => {
        let result = response.data;

        if (result.success) {
          this.bookmarkChannel.postMessage({ ticketId });

          let index = this.resultsList.map(t => t.id).indexOf(ticketId);

          if (index > -1)
            this.resultsList[index].isBookmarked = !this.resultsList[index].isBookmarked;
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    showFilters() {
      this.$emit('showFilters');
    }
  },
  mounted() {
    this.bookmarkChannel = new BroadcastChannel('bookmarkToggle')

    this.bookmarkChannel.onmessage = ({ data }) => {
      const { ticketId } = data;

      let index = this.resultsList.map(t => t.id).indexOf(ticketId);

      if (index > -1)
        this.resultsList[index].isBookmarked = !this.resultsList[index].isBookmarked;
    }

    window.scrollTo(0, 0);
  },
  beforeUnmount() {
    this.bookmarkChannel.close();
  },
  emits: ['update:selectedSorting']
}
</script>